import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import {environment} from "../../environments/environment";
import {VehicleOwner, VehicleListEntity} from '../models/sysvehicles';
;
import {Customer, Vehicle, MakeOrModel} from '../models/interfaces';


@Injectable({
  providedIn: 'root'
})
export class CustomerServices {

constructor(private http: HttpClient ) { }




public getORserachCustomers(searchString: string, page: number, pageSize: number){

    if(searchString != null &&  searchString.trim() != ""){
        return  this.searchCustomers(searchString,page ,pageSize);
    }
    else{
        return  this.getCustomers(page ,pageSize);
    }

}

public getCustomers(page: number, pageSize: number): Observable<Customer[]> {
    return this.http.get<Customer[]>(environment.APIENDPOINT + '/customers?page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public searchCustomers(searchString: string , page: number, pageSize: number): Observable<Customer[]> {
    return this.http.get<Customer[]>(environment.APIENDPOINT + '/customers/search?searchTerm='+searchString+'&page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }



  getVehicleMakes() : Observable<MakeOrModel[]> {
    return this.http.get<MakeOrModel[]>( environment.APIENDPOINT +  '/vehicles/makes',
    {
        headers: this.setHeaders(),
        responseType: 'json'
      });
    }

    getVehicleModelsforMake(makeId: number) : Observable<MakeOrModel[]> {
    return this.http.get<MakeOrModel[]>( environment.APIENDPOINT +  '/vehicles/makes/'+makeId,{
        headers: this.setHeaders(),
        responseType: 'json'
      });
    }

    public addOrUpdatecustomer (customer: Customer) {

        return this.http.post(environment.APIENDPOINT + "/customers", customer,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );

    }







  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


